// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","layoutContent":"Layout_layoutContent__4XRGI","unidentified":"Layout_unidentified__Vm22H"};